import React from "react";
import { MdShoppingCart } from "react-icons/md";
import { toast } from "react-toastify";

// store and {function} to be used in a
// non-react component such as this
import store from "../store";
import { toggleMiniCart } from "../redux/cartSlice";

// constants
const lcid = document.querySelectorAll("[data-lcid]")[0].dataset.lcid;
const cartUrl = "/api/cart/" + lcid + "/";

const getCart = async () => {
    const resp = await fetch(cartUrl, {
        headers: {
            "Content-Type": "application/json",
        },
        method: "GET",
    });

    if (resp.ok) {
        var respJson = await resp.json();

        var formElements = document.querySelectorAll("[data-formcartid]");
        if (formElements.length > 0) {
            formElements.forEach((item) => {
                item.value = respJson.cartId;
            });
        }

        return respJson;
    }
    return [];
};

const addToCart = async (code, quantity) => {
    if (quantity < 1) {
        return null;
    }

    const resp = await fetch(cartUrl, {
        headers: {
            "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify({
            code: code,
            quantity: quantity ?? 1,
        }),
    });

    if (resp.ok) {
        let respJson = await resp.json(); // name, items, status
        return respJson; // return everything to be able to do toasting
    }
    return null;
};

const deleteFromCart = async (code) => {
    const resp = await fetch(cartUrl + code, {
        headers: {
            "Content-Type": "application/json",
        },
        method: "DELETE",
    });

    if (resp.ok) {
        let respJson = await resp.json(); // name, items, status
        return respJson; // return everything to be able to do toasting
    }
    return null;
};

const deleteCart = async () => {
    const resp = await fetch(cartUrl, {
        headers: {
            "Content-Type": "application/json",
        },
        method: "DELETE",
    });

    if (resp.ok) {
        let respJson = await resp.json(); // name, items, status
        return respJson; // return everything to be able to do toasting
    }

    return null;
};

const shareCart = async (data) => {
    const resp = await fetch(cartUrl + "/shareCart", {
        headers: {
            "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(data),
    });

    if (resp.ok) {
        let respJson = await resp.json(); // name, items, status
        return respJson; // return everything to be able to do toasting
    }

    return null;
};

const cejnToast = (message, severity, hideButton) => {
    toast.clearWaitingQueue();

    toast(
        <div className={"c-toast__container" + severity}>
            <span className="c-toast__container-text">{message}</span>
            {!hideButton && (
                <button className="c-toast__container-button" onClick={() => store.dispatch(toggleMiniCart())}>
                    {i18n.getString("cejnToast.showListButton")}
                    <MdShoppingCart />
                </button>
            )}
        </div>,
        {
            className: "c-toast",
            type: severity ? toast.TYPE[severity] ?? "default" : "default",
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
        }
    );
};

export { getCart, deleteCart, addToCart, deleteFromCart, cejnToast, shareCart };
